<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
<!--      jgShuangxuan-->
      <div class="nav-item" :class="{active:type===0}" @click="toInfo('/home/jgAdmin/jgList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconinstitute"></i>
          </div>
        </div>
        机构列表
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="toInfo('/home/jgAdmin/jgForm')" v-if="user.admin_type===2 || user.admin_type===3|| user.admin_type===4">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconbiaodan2"></i>
          </div>
        </div>
        我的表单
      </div>
      <div class="nav-item" :class="{active:type===2}" @click="isshow = !isshow" v-if="user.admin_type===2">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconcaiwu2"></i>
          </div>
        </div>
        财务管理
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="duigong!==0||dongjie!==0"></i>
      </div>
      <div class="nat-item-two" v-show="type===2 || isshow">
        <div :class="{active:twoNav===0}" @click="toInfo('/home/jgAdmin/jgPay')">对公转账管理
          <i class="iconfont icondian"
             style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
             v-if="duigong!==0"></i>
        </div>
        <div :class="{active:twoNav===1}" @click="toInfo('/home/jgAdmin/jgFrozen')">冻结资金管理
          <i class="iconfont icondian"
             style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
             v-if="dongjie!==0"></i>
        </div>
      </div>
      <div class="nav-item" :class="{active:type===3}" @click="threeShow = !threeShow"  style="position: relative;">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconshenhe"></i>
          </div>
        </div>
        审核
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="jiben!==0"></i>
      </div>
      <div class="nat-item-two" v-show="type===3 || threeShow">
<!--        <div :class="{active:threeNav===0}" @click="toInfo('/home/jgAdmin/jgZhiWeiFaBuShen')">职位发布审核</div>-->
        <div :class="{active:threeNav===0}" @click="toInfo('/home/jgAdmin/jgJiChuXinXiShen')">基础信息变更审核
          <i class="iconfont icondian"
             style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
             v-if="jiben!==0"></i>
        </div>
      </div>
      <div class="nav-item" :class="{active:type===4}" @click="toInfo('/home/jgAdmin/jgAccountadd')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconjia1"></i>
          </div>
        </div>
        创建机构帐号
      </div>
      <div class="nav-item" :class="{active:type===5}" @click="toInfo('/home/jgAdmin/jgInvoice')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconfapiao"></i>
          </div>
        </div>
        发票管理
      </div>

<!--      <div class="nav-item" :class="{active:type===6}" @click="toInfo('/home/jgAdmin/jgShuangxuan')">-->
<!--        <div class="icon-yuan1">-->
<!--          <div class="icon-yuan2">-->
<!--            <i class="iconfont iconinstitute"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--        双选会机构-->
<!--      </div>-->
    </div>
    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: "jgAdmin",
    data() {
      return {
        type: '',
        twoNav: '',
        threeNav:'',
        threeShow:false,
        isshow: false, //  是否显示二级
        jiben:0,
        duigong:0,
        dongjie:0
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$store.state.topNav = 2
      this.getZnx()
    },
    methods: {
      toInfo(path) {
        this.$router.push(path)
      },
      setType(type, twoNav) {
        this.type = type
        if (this.type !== 2) {
          this.isshow = false
          this.twoNav = ''
          this.threeNav = twoNav
        } else if(this.type !== 3) {
          this.threeShow = false
          this.threeNav = ''
          this.twoNav = twoNav
        }
      },
      getZnx() {
        this.$api.apiContent.getZnx({
          adminId: this.user.id
        }).then(res => {
          this.jiben = res.data.organizationCheck
          this.duigong = res.data.transferResult
            this.dongjie = res.data.userFreezeAccount
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
</script>

<style scoped lang="scss">

</style>